module.exports = __webpack_public_path__ + "fonts/sms_70x70.30e2a05096c1192ff1f96cf11acfdf17.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/sms_70x70.png
// module id = 763
// module chunks = 9